import { useEffect, useState } from 'react';

import CapsuleAccordion from 'src/app/components/Elements/Accordion';
import { CardWithInnerTitle } from 'src/app/components/Elements/Card/CardWithInnerTitle';
import { SectionWithTitle } from 'src/app/components/Elements/SectionWithTitle';
import { Typography } from 'src/app/components/Elements/Typography';

import styles from './styles.module.scss';

type PatientEducationList = { title: string; text: string }[];

const transformPatientEducationToFAQ = (patientEducation: PatientEducationList) =>
  patientEducation?.map(({ title, text }) => ({
    question: title,
    answer: <Typography variant={'body'}>{text}</Typography>,
  }));

interface ImportantInformationSectionProps {
  warningLabels: string[];
  patientEducation: PatientEducationList;
}

export const ImportantInformationSection = ({ warningLabels, patientEducation }: ImportantInformationSectionProps) => {
  const [transformedPatientEducationToFAQ, setTransformedPatientEducationToFAQ] = useState(null);
  useEffect(() => {
    setTransformedPatientEducationToFAQ(transformPatientEducationToFAQ(patientEducation));
  }, [patientEducation]);

  return (
    <SectionWithTitle sectionTitle="Important Information">
      {warningLabels?.length > 0 && (
        <CardWithInnerTitle cardTitle={'Warnings'}>
          {warningLabels.map((warningLabel, index) => {
            const isLastWarningLabel = index === warningLabels?.length - 1;
            const warningLabelIndexAndText = `${index + 1}.  ${warningLabel}`;
            return (
              <Typography variant={'body'} marginBottom={isLastWarningLabel ? null : 's5'}>
                {warningLabelIndexAndText}
              </Typography>
            );
          })}
        </CardWithInnerTitle>
      )}

      {patientEducation?.length > 0 && (
        <CardWithInnerTitle cardTitle={'Additional information'} cardTitleMarginBottom={'s1'}>
          <CapsuleAccordion
            expandFirstQuestion={true}
            name="medication-details-faq"
            questions={transformedPatientEducationToFAQ}
            titleClassName={styles.accordionSectionTitle}
            wrapperClassName={'py-4'}
            useBlueThemedAccordion={true}
            hideOnlyFirstLine={true}
            sectionHeaderLevel={2}
          />
        </CardWithInnerTitle>
      )}
    </SectionWithTitle>
  );
};
